import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../config/config';
import { VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { AllFrontendSettingsCommand } from '../../../commands/visitor/all.frontend.settings.command';
import { ButtonTriggerEvent } from '../../../common/components';
import { BaseComponent } from '../../../common/components/base.component';
import { FacebookLoginButtonComponent } from '../../../common/components/facebook.login.button/facebook.login.button.component';
import { FacebookPost } from '../../../common/components/facebook.post/facebook.post';
import { PageSpinnerComponent } from '../../../common/components/page.spinner/page.spinner.component';
import { PlaceCategory } from '../../../common/constants/constant';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { popupCenter } from '../../../common/extensions/browser/browser.extensions';
import { GoogleMapsService } from '../../../common/services/google.maps.service';
import { ModalService } from '../../../common/services/modal.service';
import { HubPlace } from '../../../models/hub/hub.place';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { ConfigService } from '../../../services/config.service';
import { ImageService } from '../../../services/image.service';
import { ShareService } from '../../../services/share.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { AllFrontendSettingsStore, VisitorCalendarStore } from '../../../stores/visitor.calendar.store';
import { isSafari } from '../../../utils/broswerCheck';
import ShareDialogParams = facebook.ShareDialogParams;
import ShareOpenGraphDialogParams = facebook.ShareOpenGraphDialogParams;

@Component({
    selector: 'ig-place-details',
    templateUrl: './visitor.place.details.component.html',
    styleUrls: [
        './visitor.place.details.component.scss',
        '../../../../node_modules/snazzy-info-window/dist/snazzy-info-window.css'
    ],
    encapsulation: ViewEncapsulation.None
})
export class VisitorPlaceDetailsComponent extends BaseComponent implements OnInit {
    public isSideBarOpened = true;
    public lat: number = ConfigService.config.google.USCenter.lat;
    public lng: number = ConfigService.config.google.USCenter.lng;
    public mapZoom = 14;
    public places: HubPlace[];
    public place: HubPlace;
    public allPlaces: HubPlace[];
    public paginationIndex = 0;
    public paginationPageLimit = 20;
    public noMoreNext = false;
    public showingCount: string;
    public hubName: string;
    public timeout: any;
    public latLngBounds: any;
    public isUserLoggedWithFacebook: boolean;
    public isLoading = false;
    public actionCommand = new VisitorCalendarActionCommand();
    public placeFeeds: FacebookPost[];
    public simpleMenu = true;
    public placeFeedPaging: { next: string };
    public facebookLogo = config.facebook.logo;
    public featuresToggle = new HubVisitorFeatureToggle();
    public hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
    @ViewChild('loadingSpinner') loadingSpinner: PageSpinnerComponent;
    @ViewChild('sideBar') sideBar: MatSidenav;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private googleMapService: GoogleMapsService,
                private visitorCalendarStore: VisitorCalendarStore,
                private visitorApiService: VisitorApiService,
                public imageService: ImageService,
                private allFrontendSettingsStore: AllFrontendSettingsStore,
                private modalService: ModalService) {
        super({activatedRoute});
    }

    public ngOnInit() {
        let {hubName, menuType} = this.allRouteParams;
        this.hubName = hubName;
        this.facebookLogo = this.imageService.imageSourceUrl(this.facebookLogo);

        this.simpleMenu = menuType === 'simple';
        this.loadPlaces();

        this.allFrontendSettingsStore.allFrontendSettingsCommand.takeUntil(this.isDestroyed)
            .subscribe((command: AllFrontendSettingsCommand) => {
                if (command.toggle) {
                    // this.featuresToggle.tripPlanner = command.toggle.tripPlanner;
                    // this.featuresToggle.placeCalendar = command.toggle.placeCalendar;
                    // this.featuresToggle.manualEvents = command.toggle.manualEvents;
                    // this.featuresToggle.eventByGeolocation = command.toggle.eventByGeolocation;
                    this.featuresToggle = command.toggle;
                }
            });
    }

    public get isEventEnabled() {
        return this.featuresToggle.manualEvents || this.featuresToggle.eventByGeolocation;
    }

    public close() {
        this.sideBar.close();
    }

    public goBack() {
        let {category} = this.allRouteParams;
        category = PlaceCategory.getPlaceCategoryKey(category);
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeCalendar, {
            hubName: this.hubName,
            menuType: this.simpleMenu ? 'simple' : 'normal',
            category: category
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
    }

    public gotoDetails(id) {
        let {hubName, category} = this.allRouteParams;
        category = PlaceCategory.getPlaceCategoryKey(category);
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeDetails,
            {
                hubName,
                placeId: id,
                menuType: this.simpleMenu ? 'simple' : 'normal',
                category: category
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        window.location.reload();
    }

    public showInfoWindow(marker: any) {
        if (!marker._isOpen) {
            marker._openInfoWindow();
        }

        clearTimeout(this.timeout);
    }

    public hideInfoWindow(marker: any) {
        this.timeout = setTimeout(function () {
            marker._closeInfoWindow();
        }, 1500);
    }

    public getDirectionToPlaceAddress() {
        let url = config.eventShare.googleMapGetDirection
            .replace('${address}', encodeURIComponent(this.place.address.address));
        window.open(url, '_blank');
    }

    public gotoEventCalendar() {
        // if (this.isMobile && isSafari()) {
        //     setTimeout(() => {
        //         this.actionCommand.isEventCalendar = true;
        //         this.visitorCalendarStore.actionCommand.next(this.actionCommand);
        //     });
        // }

        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventCalendar,
            {
                hubName: this.hubName
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });

        this.actionCommand.isEventCalendar = true;
        this.visitorCalendarStore.actionCommand.next(this.actionCommand);
    }

    public gotoPlaceCalendar() {
        let {category} = this.allRouteParams;
        let categoryValue = category;
        let categoryPath = category;
        if (category.indexOf('-') !== -1 && category.indexOf(' ') === -1) {
            categoryValue = PlaceCategory.getPlaceCategoryValue(category);
            categoryPath = category;
        } else if (category.indexOf('-') === -1 && category.indexOf(' ') !== -1) {
            categoryPath = PlaceCategory.getPlaceCategoryKey(category);
            categoryValue = category;
        }

        // if (this.isMobile && isSafari()) {
        //     setTimeout(() => {
        //         this.actionCommand.isEventCalendar = false;
        //         this.actionCommand.queryCommand.category = categoryValue;
        //         this.visitorCalendarStore.actionCommand.next(this.actionCommand);
        //     });
        // }

        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.placeCalendar,
            {
                hubName: this.hubName,
                category: categoryPath,
                menuType: this.simpleMenu ? 'simple' : 'normal',
            }), { skipLocationChange: this.noChangeUrlWhenRedirect });

        this.actionCommand.isEventCalendar = false;
        this.actionCommand.queryCommand.category = categoryValue;
        this.visitorCalendarStore.actionCommand.next(this.actionCommand);
    }

    public showMorePlaces() {
        if (this.noMoreNext) {
            this.paginationIndex = -1;
            this.noMoreNext = false;
        }

        this.paginationIndex++;
        let start = this.paginationPageLimit * this.paginationIndex;
        let end = start + this.paginationPageLimit;
        if (end >= this.allPlaces.length) {
            end = this.allPlaces.length;
            this.noMoreNext = true;
        }
        this.places = this.allPlaces.slice(start, end);
        if (this.sideBar) {
            this.sideBar.close();
        }
        this.showingCount = `${start + 1} - ${end}`;
        this.fitBounds();
    }

    public getFacebookPlaceFeed() {
        let id = ShareService.getFacebookPlaceId(this.place.hostLink);
        // if (id && FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
        //     FB.api(config.facebook.graphApi.placePosts
        //             .replace('${accessToken}', FacebookLoginButtonComponent.userAccessToken)
        //             .replace('${placeId}', id),
        //         (response) => {
        //             this.placeFeedPaging = response.paging;
        //
        //             if (!!response.error) {
        //                 console.error(response.error);
        //                 return;
        //             }
        //
        //             this.updatePlaceFeeds(response.data);
        //         });
        // }

        let post = new FacebookPost();
        post.actions = [{ link: 'https://wwww.google.com'}, { link: 'https://facebook.com'}];
        post.from = { name: 'Aline', id: '12345678', picture: 'https://cdn2.iconfinder.com/data/icons/business-management-52/96/Artboard_20-512.png', link: 'https://facebook.com' };
        post.full_picture = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCyes0Hq_VFx85baJNqI3YUJsXpBjoaX3U49wpuQnRraz0imQTCg';
        post.id = '1233';
        post.message = 'This place is great. Came here for the Liverpool match and turns out the players are staying here, so that was an added bonus. The hotel itself is spotless, the room is so clean and has everything you need. The employees are very nice and accommodating';
        post.updated_time = new Date().toLocaleDateString();

        let post1 = new FacebookPost();
        post1.actions = [{ link: 'https://wwww.google.com'}, { link: 'https://facebook.com'}];
        post1.from = { name: 'Randy', id: '12345678', picture: 'https://cdn2.iconfinder.com/data/icons/internet-security-5/64/Account_Focus-512.png', link: 'https://facebook.com' };
        post1.full_picture = 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQA_DjPteRSjQ74py1tbIsJMipozp2p-y0xpKaufyfadxFAWTjYaQ';
        post1.id = '1233';
        post1.message = 'Stayed here many times while working in Charlotte. The rooms are always great, but the service has declined over time. Calling the front desk is met with the feeling like youre burdening the staff. I got a big sigh today before I even asked for anything';
        post1.updated_time = new Date().toLocaleDateString();

        this.placeFeeds = [post, post1];
        // this.updatePlaceFeeds(this.placeFeeds.concat([post]));
    }

    public getNextFacebookPlaceFeed(event: ButtonTriggerEvent) {
        FB.api(this.placeFeedPaging.next,
            (response) => {
                event.complete();
                this.placeFeedPaging = response.paging;

                if (!!response.error) {
                    console.error(response.error);
                    return;
                }

                this.updatePlaceFeeds(this.placeFeeds.concat(response.data));
            });
    }

    public getDirectionToEventAddress() {
        let address = this.place.address.address || this.place.address;
        let url = config.eventShare.googleMapGetDirection
            .replace('${address}', encodeURIComponent(address.toString()));
        window.open(url, '_blank');
    }

    public shareEventToFacebook() {
        let params = <ShareDialogParams>{
            method: 'share',
            href: window.location.href,
            quote: (this.place.title || this.place.name) + ' - ' + (this.place.description || this.place.about),
            picture: this.place.cover ? this.place.cover.source : null
        };
        FB.ui(params, () => {
        });
    }

    public tweetEvent() {
        let shareLink = config.eventShare.tweet
            .replace('${text}', this.place.name)
            .replace('${url}', encodeURIComponent(window.location.href));
        popupCenter(shareLink);
    }

    public mailEvent() {
        if (this.isMobile) {
            window.open(ShareService.toMailablePlace(this.place.hubName, this.place, window.location.href));
        } else {
            window.location.href = ShareService.toMailablePlace(this.place.hubName, this.place, window.location.href);
        }
    }

    private loadPlaces() {
        this.isLoading = true;
        this.loadingSpinner.show();

        let {placeId} = this.allRouteParams;
        let allPlacesWithCurrent = JSON.parse(localStorage.getItem(localStorageKeys.visitorPlaces));

        let needToLoadPlaces = false;
        if (!allPlacesWithCurrent) {
            needToLoadPlaces = true;
        } else {
            this.place = allPlacesWithCurrent.first(x => x._id === placeId);
            if (!this.place) {
                needToLoadPlaces = true;
            } else {
                this.setMeta();
            }
        }

        if (needToLoadPlaces) {
            this.getPlaces().subscribe(data => {
                this.place = data.first(x => x._id === placeId);
                localStorage.setItem(localStorageKeys.visitorPlaces, JSON.stringify(data.slice(0, 1000)));
                if (!this.place) {
                    this.modalService.showErrorModal('Place id is wrong!');
                    this.gotoPlaceCalendar();
                    return;
                }
                this.setMeta();
                this.pagination(data);
            });
            return;
        }
        this.pagination(allPlacesWithCurrent);
        this.getPlaces().subscribe(data => {
            this.allPlaces = data;
            localStorage.setItem(localStorageKeys.visitorPlaces, JSON.stringify(data.slice(0, 1000)));
        });
    }

    private shareOverrideOGMeta(overrideLink?, overrideTitle?, overrideDescription?, overrideImage?) {
        FB.ui(<ShareOpenGraphDialogParams>{
                method: 'share_open_graph',
                action_type: 'og.likes',
                href: '',
                action_properties: {
                    'og:url': window.location.href,
                }
                // action_properties: JSON.stringify({
                //     object: {
                //         'og:url': overrideLink,
                //         'og:title': overrideTitle,
                //         'og:description': overrideDescription,
                //         'og:image': overrideImage
                //     }
                // })
            },
            function (response) {
                // Action after response
            });
    }

    private setMeta() {
        // this.shareOverrideOGMeta();
        // this.createMeta('og:description', this.place.description||this.place.about);
        // this.createMeta('og:title', this.place.name||this.place.title);
        // this.createMeta('og:url', window.location.href);
        // this.createMeta('og:image', this.place.cover?this.place.cover.source:'');
    }

    private createMeta(name, content) {
        let metaTag = document.createElement('meta');
        metaTag.name = name;
        metaTag.content = content;
        document.getElementsByTagName('head')[0].appendChild(metaTag);
    }

    private pagination(allPlacesWithCurrent) {
        this.getFacebookPlaceFeed();
        this.allPlaces = allPlacesWithCurrent.filter(x => x._id !== this.place._id);
        this.paginationIndex = 0;

        if (this.allPlaces.length > this.paginationPageLimit) {
            let max = this.paginationPageLimit * (this.paginationIndex + 1);
            this.places = this.allPlaces.slice(0, max);
            this.showingCount = `${this.paginationPageLimit * this.paginationIndex + 1} - ${max}`;
        } else {
            this.places = allPlacesWithCurrent;
        }

        if (!this.place.lat) {
            this.mapZoom = ConfigService.config.google.fullUSMapZoom;
        }
        this.fitBounds();
        this.isLoading = false;
        this.loadingSpinner.hide();
    }

    private getPlaces(): Observable<HubPlace[]> {
        return this.visitorApiService.getPlaces(this.hubName, {page: 1, limit: 0, category: 'All'});
    }

    private updatePlaceFeeds(placeFeeds) {
        this.placeFeeds = placeFeeds;
        this.placeFeeds.forEach(x => {
            x.from.link =
                config.facebook.graphApi.profile.replace('${userId}', x.from.id);
            x.from.picture =
                config.facebook.graphApi.profilePictureSquare.replace('${userId}', x.from.id);
        });
    }

    private fitBounds() {
        this.googleMapService.getGoogle().then(() => {
            this.latLngBounds = new google.maps.LatLngBounds();

            this.places.forEach(x => {
                if (x.lat && x.lng) {
                    this.latLngBounds.extend(new google.maps.LatLng(x.lat, x.lng));
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.details/visitor.place.details.component.ts